import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';


import { DefaultServiceGetCards } from './default-service-get-cards.service';
import { Configuration } from '../../../../gen/swagger-api';
import {DefaultServiceGetSubscriptionPools} from './default-service-get-subscription-pools.service';

@NgModule({
  imports:      [ CommonModule, HttpClientModule ],
  declarations: [],
  exports:      [],
  providers: [
    DefaultServiceGetCards, DefaultServiceGetSubscriptionPools ]
})
export class ApiModuleForGetCards {
    public static forRoot(configurationFactory: () => Configuration): ModuleWithProviders {
        return {
            ngModule: ApiModuleForGetCards,
            providers: [ { provide: Configuration, useFactory: configurationFactory } ]
        }
    }

    constructor( @Optional() @SkipSelf() parentModule: ApiModuleForGetCards) {
        if (parentModule) {
            throw new Error('ApiModule is already loaded. Import your base AppModule only.');
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/workaround/api.module.ts